import React from 'react';
import styles from './ProgressBar.module.css';

export default function ProgressBar({ percentage = 0, height = 'default', showLabel = false, dangerPercentage = 0 }) {
  const clampedPercentage = Math.min(100, Math.max(0, percentage));
  const clampedDanger = Math.min(100 - clampedPercentage, Math.max(0, dangerPercentage));

  return (
    <div className={styles.wrapper}>
      {showLabel && (
        <span className={styles.label}>{clampedPercentage}%</span>
      )}
      <div className={`${styles.track} ${styles[height]}`}>
        <div
          className={styles.fill}
          style={{ width: `${clampedPercentage}%` }}
        />
        {clampedDanger > 0 && (
          <div
            className={styles.fillDanger}
            style={{ width: `${clampedDanger}%`, left: `${clampedPercentage}%` }}
          />
        )}
      </div>
    </div>
  );
}
